/**
 * * Модель запроса на обновление статуса задачи
 */
export default class TaskUpdateStatusRequest  {
	/**
	 * * Ид задачи
	 */
	TaskId!: number;
	/**
	 * * Статус
	 */
	StatusId!: number;
	/**
	 * * Флаг который при true и при выставленном статусе завергено (глобальном) меняет статусы и на дочерних задачах
	 */
	CompleteChildren: boolean = false;
	constructor(obj?: Partial<TaskUpdateStatusRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
